<footer class="footer w-full bg-brandPrimary text-white py-10 px-4 desktop:py-14 desktop:px-24">
  <section class="mx-auto">
    <figure class="flex justify-between flex-wrap mb-7 desktop:mb-10">
      <img src="{{ brandLogo }}" alt="Driven Entrepreneur Logo" class="footer__brandLogo max-w-full"/>
    </figure>

    <div class="footer__disclaimer text-sm leading-6 font-normal mb-4 desktop:mb-7">
      <p>{{ disclaimer }}</p>
    </div>

    <div class="footer__additionalContent text-xs leading-4 text-center flex flex-col gap-1 desktop:flex-row desktop:justify-between">
      <div>© {{ currentYear }}  GHRH SA, LLC. All Rights Reserved.</div>
      <div>{{ address }}</div>
      <div class="flex flex-wrap items-center justify-center text-xs max-w-64 mx-auto desktop:max-w-none desktop:mx-0">
        <ng-container *ngFor="let link of visibleLinks; let last = last">
          <a [href]="link.url" [target]="link.target || '_blank'"
            class="text-white underline row-gap-1 transition-opacity duration-300 hover:opacity-80 cursor-pointer">
            {{ link.label }}
          </a>
          <span *ngIf="!last" class="mx-1">|</span>
        </ng-container>
      </div>
    </div>
  </section>
</footer>